/**
 * Paser the Safari Mobile (iOS Safari), returns undefined if not on Safari Mobile.
 */
export function safariMobileInfo() {
  const userAgent = navigator.userAgent;
  
  if (/iP(hone|od|ad)/.test(userAgent) && /AppleWebKit/.test(userAgent) && !/CriOS/.test(userAgent)) {
    let majorVersion = 0, minorVersion = 0;
    
    const versionMatch = userAgent.match(/OS (\d+)_(\d+)/);
    if (versionMatch) {
      majorVersion = parseInt(versionMatch[1], 10);
      minorVersion = parseInt(versionMatch[2], 10);
    } else { // Fallback for major version only
      const majorOnlyMatch = userAgent.match(/OS (\d+)_/);
      if (majorOnlyMatch) {
        majorVersion = parseInt(majorOnlyMatch[1], 10);
      }
    }
    
    return { os: { majorVersion, minorVersion } };
  }
  
  return undefined; // Not on Mobile Safari
}
